<div class="standard-dialog">
  <div class="header" mat-dialog-title>
    <div class="title-section">
      <h2>{{ 'MySpace.Profile' | translate }}</h2>
    </div>
    <button mat-icon-button (click)="dialogRef.close()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="form-content">
    @if (itemForm) {
      <div class="profile-photo-container d-flex flex-column align-items-center mb-4">
        <label class="photo-wrapper cursor position-relative">
          @if (loadingPhoto) {
            <div class="w-100 h-100 d-flex align-items-center justify-content-center bg-light">
              <mat-spinner diameter="24"></mat-spinner>
            </div>
          } @else {
            <img class="avatar-img" [src]="user?.photo || 'assets/images/no_user.png'" alt="User profile picture" />
          }
          <div class="camera-overlay d-flex align-items-center justify-content-center">
            <mat-icon>photo_camera</mat-icon>
          </div>
          <input type="file" hidden accept="image/*" (change)="onFileSelected($event)" [disabled]="uploadingPhoto" />
        </label>
        @if (uploadingPhoto) {
          <div class="uploading-text mt-2 text-muted" style="font-size: 0.8rem">Uploading...</div>
        }
      </div>

      <form [formGroup]="itemForm" (ngSubmit)="updateProfile(itemForm.value)">
        <div class="w-100 mb-3">
          <mat-label class="form-label mb-1">Prénom</mat-label>
          <mat-form-field subscriptSizing="dynamic" appearance="fill" class="soft-input w-100">
            <input matInput formControlName="firstName" placeholder="Prénom" />
          </mat-form-field>
        </div>

        <div class="w-100 mb-3">
          <mat-label class="form-label mb-1">Nom</mat-label>
          <mat-form-field subscriptSizing="dynamic" appearance="fill" class="soft-input w-100">
            <input matInput formControlName="lastName" placeholder="Nom" />
          </mat-form-field>
        </div>

        <div class="w-100 mb-3">
          <mat-label class="form-label mb-1">E-mail</mat-label>
          <mat-form-field subscriptSizing="dynamic" appearance="fill" class="soft-input w-100 disabled-input">
            <input matInput formControlName="email" placeholder="E-mail" />
          </mat-form-field>
        </div>
      </form>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="footer">
    <div class="right-actions w-100 d-flex justify-content-end gap-2">
      <button mat-button (click)="dialogRef.close()">{{ 'Global.Cancel' | translate }}</button>
      <button mat-flat-button color="primary" [disabled]="!itemForm || itemForm.invalid || loading || uploadingPhoto" (click)="updateProfile(itemForm.value)">
        {{ 'MySpace.UpdateProfile' | translate }}
      </button>
    </div>
  </mat-dialog-actions>
</div>
